import { render } from "./OverlayDemo.vue?vue&type=template&id=0b576e20"
import script from "./OverlayDemo.vue?vue&type=script&lang=js"
export * from "./OverlayDemo.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__